var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistYesDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_153",
    "data-name": "Raggruppa 153",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_162",
    "data-name": "Tracciato 162",
    d: "M15,30A15,15,0,1,0,0,15,15,15,0,0,0,15,30Z",
    fill: "#96a1a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_163",
    "data-name": "Tracciato 163",
    d: "M7.241,12.423a1.977,1.977,0,1,0-1.977-1.977A1.957,1.957,0,0,0,7.241,12.423Z",
    transform: "translate(1.316 2.117)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_164",
    "data-name": "Tracciato 164",
    d: "M17.55,12.423a1.977,1.977,0,1,0-1.977-1.977A1.977,1.977,0,0,0,17.55,12.423Z",
    transform: "translate(3.893 2.117)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_165",
    "data-name": "Tracciato 165",
    d: "M13.05,20.151c3.477,0,4.858-2.71,5.25-5.847H7.8C8.192,17.458,9.573,20.151,13.05,20.151Z",
    transform: "translate(1.95 3.576)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistYesDisabled);
export default __webpack_public_path__ + "static/media/ChecklistYesDisabled.3810dd72c23c9c6c1900aa460db30279.svg";
export { ForwardRef as ReactComponent };